import type { MutableRefObject } from "react";
import { createContext, useContext } from "react";

import type { LibSvgRenderer } from "features/engine2D/svgRenderer";

export const SvgRendererContext = createContext<MutableRefObject<LibSvgRenderer | null>>({ current: null });

export function useSvgRenderer() {
    return useContext(SvgRendererContext);
}
